import React, { useEffect } from 'react';
import { Box, Button, CircularProgress, Container, Paper, Stack, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectAuth } from '../authentication/authSlice';
import { fetchSettingsAsync, selectSettings } from '../admin/settings/settingsSlice';
import { useNavigate } from 'react-router-dom';
import { createAttemptAsync, selectAttempts } from './TestView/attemptSlice';

const ApplicantLandingPage = () => {
  const authState = useAppSelector(selectAuth);
  const attemptState = useAppSelector(selectAttempts);
  const { settings } = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchSettingsAsync());
  }, []);

  useEffect(() => {
    if (attemptState.attempt) {
      navigate('test');
    }
  }, [attemptState.attempt]);

  const handleStartTest = () => {
    dispatch(createAttemptAsync());
  };
  return (
    <Box marginTop={1}>
      <Container maxWidth="sm">
        {authState.loading || attemptState.loading ? (
          <CircularProgress />
        ) : (
          <Paper>
            <Stack>
              <Typography align="center">Welcome to the analytics test</Typography>
              <Typography align="center">
                You are signed in as {authState.applicant?.firstName} {authState.applicant?.lastName}
              </Typography>
              <Typography align="center">You have {settings?.testTime} minutes to complete the test</Typography>
              <Button variant="contained" onClick={handleStartTest}>
                Start Test
              </Button>
            </Stack>
          </Paper>
        )}
      </Container>
    </Box>
  );
};

export default ApplicantLandingPage;
